import { render, staticRenderFns } from "./MeetJitsi.vue?vue&type=template&id=571bdf5c&scoped=true&"
import script from "./MeetJitsi.vue?vue&type=script&lang=js&"
export * from "./MeetJitsi.vue?vue&type=script&lang=js&"
import style0 from "./MeetJitsi.vue?vue&type=style&index=0&id=571bdf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bdf5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
